import Maintenance from ".";

export default function MaintenanceExamples() {
  return <Maintenance />;
}
